import * as React from 'react';
import ReactDOM from 'react-dom/client';
import {App} from './App';
import './index.css';
import {defaultLocale, LocaleManager} from "@nic-react-i18n/core";
import {useConfiguration} from "@nic-react-i18n/i18next";
import keycloak from "./keycloak";
import {AuthError, AuthEvent, AuthProvider} from "@nic-react/auth";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import Spinner from "./components/Spinner/Spinner";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60,
            refetchOnWindowFocus: false,
            retry: false
        },
    },
});

const Main = () => {
    return (
        <React.Suspense fallback={<Spinner/>}>
            <LocaleManager locale={defaultLocale()} impl={useConfiguration()}>
                <QueryClientProvider client={queryClient}>
                    <AuthProvider
                        authClient={keycloak}
                        onEvent={(event: AuthEvent) => {
                            //console.log('Event: ', event);
                            switch (event) {
                                case "onAuthLogout":
                                    console.log('onAuthLogout: ', keycloak.authenticated)
                                    if (!keycloak.authenticated) {
                                        console.log('TokenLogout');
                                        keycloak.login({redirectUri: `${window.location.origin}`})
                                    }
                                    break;
                                case "onReady":
                                    break;
                                case "onTokenExpired":
                                    console.log('TokenExpired', );
                                    (window as any)['keycloak'] = keycloak;
                                    break;
                                case "onAuthSuccess":
                                    (window as any)['keycloak'] = keycloak;
                                    break;
                            }
                        }}
                        onError={(errorEvt: string, error?: AuthError) => {
                            (window as any)['keycloak'] = undefined;

                            keycloak.login({redirectUri: `${window.location.origin}`})
                        }}
                    >
                        <App />
                    </AuthProvider>
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </LocaleManager>
        </React.Suspense>
    )
}


root.render(
    <React.StrictMode>
        <Main/>
    </React.StrictMode>
);
//registerServiceWorker();
